export var publishDuplicateStudentDetectedEvent = function publishDuplicateStudentDetectedEvent(_ref) {
  var source = _ref.source,
    matchingFields = _ref.matchingFields,
    trackEvent = _ref.trackEvent;
  var eventMap = {
    studentProfile: {
      group: 'Student Profile',
      event: 'Student Profile - Duplicate Student Detected'
    },
    addNewStudentModal: {
      group: 'Add New Student Modal',
      event: 'ANSM - Duplicate Student Detected'
    }
  };
  trackEvent({
    data: {
      matching_fields: matchingFields
    },
    event: eventMap[source].event,
    group: eventMap[source].group
  });
};
export var publishDuplicateStudentActionEvent = function publishDuplicateStudentActionEvent(_ref2) {
  var source = _ref2.source,
    action = _ref2.action,
    trackEvent = _ref2.trackEvent;
  var eventMap = {
    studentProfile: {
      group: 'Student Profile',
      event: 'Student Profile - Duplicate Student Action'
    },
    addNewStudentModal: {
      group: 'Add New Student Modal',
      event: 'ANSM - Duplicate Student Action'
    }
  };
  var actionMap = {
    backToEditing: 'Back to editing',
    addDuplicateStudent: 'Add duplicate student',
    viewProfile: 'View profile'
  };
  trackEvent({
    data: {
      action: actionMap[action]
    },
    event: eventMap[source].event,
    group: eventMap[source].group
  });
};